import Utils from './Utils'

class Blogs {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._utils = new Utils()
    }

    onInit () {
        this.initLoadMore()
        this.fadeInBlogs()
    }

    fadeInBlogs (elem) {
        const _this = this
        const blogs = elem !== null ? this._elem : elem

        blogs.querySelectorAll('.hide-fade-in').forEach(function (e) {
            _this._utils.fadeIn(e, 'block')
        })
    }

    initLoadMore () {
        const loadMore = this._elem.querySelector('#js-blogs-load')
        const loadMoreButton = this._elem.querySelector('.js-load-more-button')
        const blogs = this._elem.querySelector('#js-blog-items')
        const _this = this

        function loadMoreWork () {
            loadMoreButton.removeEventListener('click', loadMoreWork)
            let nextPage = loadMoreButton.getAttribute('data-next-page')

            _this._utils.getPage(nextPage, function (status, response) {
                if (status === 200) {
                    let newBlogs = response.querySelector('#js-blog-items')
                    let newLoadMore = response.querySelector('#js-blogs-load')
                    blogs.innerHTML = blogs.innerHTML + newBlogs.innerHTML
                    loadMore.innerHTML = newLoadMore.innerHTML
                    _this.fadeInBlogs(blogs)
                    _this.initLoadMore()
                }
            })
        }

        if (loadMore && loadMoreButton) {
            loadMoreButton.addEventListener('click', loadMoreWork)
        }
    }
}

export default Blogs



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Blogs.js